const storeName = 'view-elevator-book-process'

export const process = {
  namespaced: true,
  state: {
    processResult: localStorage.getItem(storeName + '-process'),
    username: localStorage.getItem(storeName + '-username'),
    rideCount: localStorage.getItem(storeName + '-ride-count'),
    facility: localStorage.getItem(storeName + '-facility'),
    fileNumber: localStorage.getItem(storeName + '-file-number'),
    processSearch: null,
  }, mutations: {
    storeProcessResult(state, result) {
      state.processResult = result;
      localStorage.setItem(storeName + '-process', JSON.stringify(result) ? JSON.stringify(result) : '');
    },
    storeUsername(state, name) {
      state.username = name;
      localStorage.setItem(storeName + '-username', name ? name : '');
    },
    storeRideCount(state, ride) {
      state.rideCount = ride;
      localStorage.setItem(storeName + '-ride-count', ride ? ride : '');
    },
    storeFileNumber(state, fileNumber) {
      state.fileNumber = fileNumber;
      localStorage.setItem(storeName + '-file-number', fileNumber ? fileNumber : '');
    },
    storeFacility(state, id) {
      state.facility = id;
      localStorage.setItem(storeName + '-facility', id ? id : '');
    },
    storeProcessSearch(state, processSearch) {
      state.processSearch = processSearch;
    }
  }
}
